var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "50px",
    height: "50px",
    viewBox: "0,0,256,256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(32,32) scale(0.75,0.75)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128,298.66667c-94.2566,0 -170.66667,-76.41007 -170.66667,-170.66667v0c0,-94.2566 76.41007,-170.66667 170.66667,-170.66667v0c94.2566,0 170.66667,76.41007 170.66667,170.66667v0c0,94.2566 -76.41007,170.66667 -170.66667,170.66667z",
    id: "shape"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.12,5.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37,4.00391c-2.30475,-0.00013 -4.61023,0.87831 -6.36523,2.63281l-5,5c-2.492,2.492 -3.20425,6.09056 -2.15625,9.22656l3.5918,-3.5918c0.15,-1.027 0.60358,-2.01764 1.39258,-2.80664l5,-5c0.975,-0.974 2.25711,-1.46289 3.53711,-1.46289c1.28,0 2.56116,0.48789 3.53516,1.46289c1.949,1.95 1.949,5.12131 0,7.07031l-5,5c-0.789,0.789 -1.77864,1.24158 -2.80664,1.39258l-3.59375,3.59375c0.928,0.31 1.89428,0.47461 2.86328,0.47461c2.305,0 4.61023,-0.87781 6.36523,-2.63281l5,-5c3.51,-3.509 3.509,-9.21756 0,-12.72656c-1.755,-1.754 -4.05853,-2.63269 -6.36328,-2.63281zM30.96094,16.98047c-0.5196,0.01548 -1.01276,0.23264 -1.375,0.60547l-12,12c-0.52248,0.50163 -0.73295,1.24653 -0.55024,1.94742c0.18271,0.70088 0.73006,1.24823 1.43094,1.43094c0.70088,0.18271 1.44578,-0.02776 1.94742,-0.55024l12,-12c0.59152,-0.57498 0.76938,-1.45413 0.44787,-2.21382c-0.32151,-0.75969 -1.07643,-1.24408 -1.90099,-1.21977zM18.44922,23.02344c-2.45208,-0.12478 -4.94275,0.74233 -6.8125,2.61133l-5,5c-3.509,3.509 -3.509,9.21952 0,12.72852c1.755,1.754 4.05928,2.63086 6.36328,2.63086c2.304,0 4.60828,-0.87781 6.36328,-2.63281l5,-5c2.492,-2.492 3.2062,-6.09056 2.1582,-9.22656l-3.59375,3.59375c-0.15,1.027 -0.60358,2.01764 -1.39258,2.80664l-5,5c-1.949,1.95 -5.12131,1.95 -7.07031,0c-1.949,-1.95 -1.949,-5.12131 0,-7.07031l5,-5c0.789,-0.789 1.77964,-1.24353 2.80664,-1.39453l3.5918,-3.5918c-0.784,-0.262 -1.5967,-0.41348 -2.41406,-0.45508z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyLink);
export default __webpack_public_path__ + "static/media/copy-link.64ea7e74ee700dc8c215781dfa362bda.svg";
export { ForwardRef as ReactComponent };